class TSHeader extends HTMLElement {
  constructor() {
    super();
    this.mobileMenu = this.querySelector("#HeaderMobileMenu");
    this.allAnnouncementsHeight = 1;
  }

  connectedCallback() {
    this.initClickEvent();

    this.calcHeader();
    window.addEventListener('scroll', () => {
      this.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
    });
    
  }

  calcHeader() {
    const updateHeaderHeights = () => {
      this.headerHeight = this.getBoundingClientRect().height;
      const wrapper = this.querySelector(".ts-header__wrapper");
      const preHeader = this.querySelector(".ts-header__pre-header");
      const wrapperHeight = wrapper ? wrapper.getBoundingClientRect().height : this.headerHeight;
      const overlayHeight = preHeader ? wrapperHeight : this.headerHeight;

      document.documentElement.style.setProperty("--ts-header-height", `${this.headerHeight}px`);
      document.documentElement.style.setProperty("--ts-header-overlay-height", `${overlayHeight}px`);

      const announcements = document.querySelectorAll(".announcement");
      this.allAnnouncementsHeight = Math.max(Array.from(announcements).reduce((sum, el) => {
        return sum + el.offsetHeight;
      }, 0), 1);

      this.classList.toggle("sticky", window.scrollY >= this.allAnnouncementsHeight);
    };

    const headerObserver = new ResizeObserver(updateHeaderHeights);

    headerObserver.observe(this);
    updateHeaderHeights();
  }

  initClickEvent() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        
        switch (e.target.dataset.action) {
          case "open-menu":
            this.mobileMenu.classList.add("open");
            document.documentElement.style.overflow = "hidden";
            break;
          case "close-menu":
            this.mobileMenu.classList.remove("open");
            document.documentElement.style.overflow = null;
            break;

        }
      }

    })
  }
}

customElements.define("ts-header", TSHeader)